import proj4 from 'proj4'

/**
 * Type definition of the RD New format.
 */
const RD_NEW =
    '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +towgs84=565.2369,50.0087,465.658,-0.406857330322398,0.350732676542563,-1.8703473836068,4.0812 +no_defs'

/**
 * Type definition of the WGS84 format.
 */
const WGS84 = 'WGS84'

/**
 * @typedef {number} RDNewLongitude Floating point number coordinate in RD New format.
 * @typedef {number} RDNewLatitude Floating point number coordinate in RD New format.
 *
 * @typedef {number} WGS84Longitude Floating point number coordinate in WGS84 format.
 * @typedef {number} WGS84Latitude Floating point number coordinate in WGS84 format.
 */

/**
 * Converts an array of RD New coordinates to an array of WGS84 coordinates.
 * @link https://pdok-ngr.readthedocs.io/handleidingen.html#in-de-browser-proj4js
 * @link http://proj4js.org/
 * @param {[RDNewLongitude, RDNewLatitude]} lngLatArray
 * @returns {[WGS84Longitude, WGS84Latitude]}
 */
export default function convertCoordinates(lngLatArray) {
    return proj4(RD_NEW, WGS84, lngLatArray)
}



// WEBPACK FOOTER //
// ./scripts/util/convertCoordinates.js